import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { EventSummaryDto } from '@aoe/client';
import { divIcon, map, marker, popup, tileLayer } from 'leaflet';
import * as _ from 'lodash-es';
import { formatShortDate } from 'src/app/core/helpers/Date.helpers';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'aoe-event-map',
  templateUrl: './event-map.component.html',
  styleUrls: ['./event-map.component.scss'],
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule
  ]
})
export class EventMapComponent implements OnInit, AfterViewInit {

  public isBrowser = isPlatformBrowser(this.platformId);
  // public L = null;

  private map: any;
  private markersLatLng: any[][] = [];

  public dateHelper = formatShortDate;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(MAT_DIALOG_DATA) public data: EventSummaryDto[],
    private readonly sanitize: DomSanitizer
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.initMap();

    this.data.forEach(event => {
      this.addMaker(event);
    });

    this.map.fitBounds(this.markersLatLng);
  }

  private pictureLink(picture: string): SafeUrl {
    return this.sanitize.bypassSecurityTrustResourceUrl(`${environment.apiUrl}/event/photo/${picture}`)
  }

  private initMap(): void {
    this.map = map('map', {
      center: [44.10924, 7.20184],
      zoom: 13,
      scrollWheelZoom: false
    });

    const tiles = tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 17,
      minZoom: 3,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">Open Street Map</a>'
    });

    tiles.addTo(this.map);
  }

  private addMaker(c: any): void {
    const dateEnd = !_.isNull(c.date.end) ? `au ${this.dateHelper(c.date.end)}` : '';
    const popupMarker = popup()
      .setLatLng([c.coordinates.lat, c.coordinates.long])
      .setContent(`
      <header class='text-center'>
      <h4 class='popup-title'>${c.name}</h4>
      <h6 class='popup-subtitle'>${c.city}</h6>
      <h6 class='popup-subtitle-date'>${_.upperFirst(this.dateHelper(c.date.start))} ${_.upperFirst(dateEnd)}</h6>
      </header>
      
      <div>
      <img class='popup-img' src='${this.pictureLink(c.picture)}'></img>
        <section class='event-description'>
        ${c.description}
        </section>

        <section class='distance'>

        </section>

      </div>      
      `)

    const markerPoint = marker([c.coordinates.lat, c.coordinates.long], {
      icon: divIcon(
        {
          html: `
      <div
      style="width: 30px !important;
      height: 30px !important;
      background-image: url('../../assets/icon/run.svg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;">
      </div>`,
          iconSize: [0, 0],
          iconAnchor: [15, 30]
        })
    }).bindPopup(popupMarker);

    this.markersLatLng.push([c.coordinates.lat, c.coordinates.long]);

    markerPoint.addTo(this.map);
  }
}
